import React, { useState } from 'react'
import {
  Button,
  ContextMenu,
  makeButtonWithMenu,
  Flex,
  FlexItem,
  IconArrow1Down
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { modalSaveCallback } from 'Pages/TemplateEdit/recoil/callbacks/callbacks'

import { beePluginState } from '../recoil/state/editor'
import styled from '@emotion/styled'
import { storeGet, STORE_KEY_ACCOUNT } from 'mailup-react-helpers'
import { modalContentsDefaultsState } from 'Components/ModalContentDefaults/recoil/state'

const SaveTemplateButton = () => {
  const intl = useIntl()
  const history = useHistory()
  const { mode } = useParams()
  const [showStructure, setShowStructure] = useState(false)

  const account = storeGet(STORE_KEY_ACCOUNT)
  const {
    instance: beePluginInstance,
    loaded: beePluginLoaded
  } = useRecoilValue(beePluginState)
  const setModalContentsDefaults = useSetRecoilState(modalContentsDefaultsState)
  const modalSave = useRecoilCallback(modalSaveCallback, [])

  const handleClickBtn = value => {
    switch (value) {
      case 'SAVE': {
        if (mode === 'edit') {
          beePluginInstance.save()
        } else {
          modalSave()
        }
        break
      }
      case 'EXIT': {
        history.push('/templates/bee')
        break
      }
      case 'SAVE_AS_NEW': {
        modalSave()
        break
      }
      case 'PREVIEW': {
        break
      }
      case 'STRUCTURE': {
        beePluginInstance.toggleStructure()
        setShowStructure(!showStructure)
        break
      }
      case 'CONTENTDEFAULTS': {
        if (
          account.IdOffer === 3 ||
          account.IdOffer === 2 ||
          account.IdOffer === 1 ||
          account.IsOfferLight
        ) {
          setModalContentsDefaults(prev => ({
            ...prev,
            show: true
          }))
        } else {
          history.push(`/messages/email/contentdefaults`)
        }
        break
      }
    }
  }

  const ButtonComponent = () => (
    <Button
      kind='primary'
      data-mu-test='save-template-menu'
      disabled={!beePluginLoaded}
    >
      <IconArrow1Down />
    </Button>
  )

  const MenuComponent = () => {
    let items = [
      {
        label: showStructure
          ? intl.formatMessage({ id: 'Load.Bee.HideStructure' })
          : intl.formatMessage({ id: 'Load.Bee.Structure' }),
        value: 'STRUCTURE',
        onClick: handleClickBtn
      }
    ]

    if (mode === 'edit') {
      items = [
        {
          label: intl.formatMessage({ id: 'Load.Bee.SaveAsNewTemplate' }),
          value: 'SAVE_AS_NEW',
          onClick: handleClickBtn
        },
        ...items
      ]
    }

    items = [
      ...items,
      {
        separator: true,
        label: intl.formatMessage({
          id: 'Load.NavMenu.EmailContentDefaults'
        }),
        value: 'CONTENTDEFAULTS',
        onClick: handleClickBtn
      }
    ]

    return <ContextMenu items={items} />
  }

  const ButtonWithMenu = makeButtonWithMenu(ButtonComponent, MenuComponent)

  return (
    <Flex columnGap='8px' justifyContent='flex-end'>
      <Button
        kind='neutral'
        onClick={() => handleClickBtn('EXIT')}
        data-mu-test='save-template-exit'
      >
        {intl.formatMessage({ id: 'Load.Common.Exit' })}
      </Button>

      <StyledSaveMessageContainer>
        <Flex alignItems='center'>
          <Button
            kind='primary'
            data-mu-test='save-template-save'
            onClick={() => handleClickBtn('SAVE')}
            disabled={!beePluginLoaded}
          >
            {mode === 'edit'
              ? intl.formatMessage({ id: 'Load.Common.SaveAndExit' })
              : intl.formatMessage({ id: 'Load.Bee.SaveAsNewTemplate' })}
          </Button>

          <ButtonWithMenu />
        </Flex>
      </StyledSaveMessageContainer>
    </Flex>
  )
}

export default SaveTemplateButton

const StyledSaveMessageContainer = styled(FlexItem)`
  .e-button:first-of-type {
    border-radius: 4px 0 0 4px;
    &:hover {
      cursor: pointer;
    }
  }

  .c-button-with-menu__button > .e-button {
    border-radius: 0 4px 4px 0;
    margin-left: 1px;
    padding: 0 13px;
  }

  .c-button-with-menu__menu {
    right: -8px;
  }
`
